import { IStatusConfig } from '../../../components/StatusBadge'
import {
  StudyCreditAbraUnit,
  StudyCreditCourseFormat,
  StudyCreditEducationFormat,
  StudyCreditInstitution,
  StudyCreditStatus
} from '../../../services/StudyCreditRequest/types'

// Kanban columns, in board order (mirrors StudyCreditRequest::STATUSES on the backend).
export const STUDY_CREDIT_STATUSES: StudyCreditStatus[] = [
  'requested',
  'missing_docs',
  'pedagogical_analysis',
  'exam',
  'commercial',
  'completed'
]

/**
 * Status do pedido. Rótulo e cor no mesmo registro, na forma que o `<StatusBadge>` lê — eram dois
 * `Record` paralelos, que é como as cópias de status do painel foram divergindo.
 */
export const STUDY_CREDIT_STATUS: Record<StudyCreditStatus, IStatusConfig> = {
  requested: { label: 'Solicitações', colorScheme: 'blue' },
  missing_docs: { label: 'Docs Faltantes', colorScheme: 'orange' },
  pedagogical_analysis: { label: 'Análise Pedagógica', colorScheme: 'purple' },
  exam: { label: 'Prova', colorScheme: 'cyan' },
  commercial: { label: 'Comercial', colorScheme: 'magenta' },
  completed: { label: 'Concluído', colorScheme: 'green' }
}

export const RESPONSIBLE_LABELS: Record<'student' | 'other', string> = {
  student: 'O Próprio Aluno',
  other: 'Outros'
}

export const EDUCATION_FORMAT_LABELS: Record<StudyCreditEducationFormat, string> = {
  in_person: 'Presencial',
  live_online: 'Online Ao Vivo'
}

export const INSTITUTION_LABELS: Record<StudyCreditInstitution, string> = {
  abra: 'ABRA',
  other_institution: 'Outras instituições',
  self_taught: 'Autodidata'
}

export const ABRA_UNIT_LABELS: Record<StudyCreditAbraUnit, string> = {
  moema_brooklin: 'Moema/Brooklin',
  extinct_units: 'Unidades Extintas'
}

export const COURSE_FORMAT_LABELS: Record<StudyCreditCourseFormat, string> = {
  in_person: 'Cursos Presenciais',
  recorded: 'Cursos Online',
  live_online: 'Cursos EAD Ao Vivo'
}

export const MOEMA_AWARENESS_TEXT =
  'Estou ciente que, dependendo da data em que realizei meu curso, talvez precise enviar documentos ou trabalhos ' +
  'escolares para comprovar minha conclusão e aprendizado.'

export const EXTINCT_AWARENESS_TEXT =
  'Estou ciente de que meu aproveitamento de estudos será avaliado através dos trabalhos e documentos escolares ' +
  'do curso que participei nas unidades extintas da ABRA.'

export const DECLARATION_NO_NEW_REQUEST_TEXT =
  'Declaro estar ciente de que não poderei fazer nova solicitação de Aproveitamento de Estudos após iniciar o curso.'

export const DECLARATION_AUTHENTICITY_TEXT =
  'Declaro que todas as informações, trabalhos e portfólios submetidos são autênticos e verdadeiros. Reconheço que ' +
  'a apresentação de informações falsas poderá resultar em sanções conforme os artigos 171 e 299 do Código Penal.'

// Limites do upload, espelhando StoreStudyCreditRequestRequest::FILE_RULES (max:10240). A lista
// de extensões e a validação em si são do token `attachment` em `components/FileInput/fileTypes.ts`.
export const MAX_FILE_SIZE_MB = 10

// nginx/php cortam o request em 50MB; a margem cobre o overhead do multipart. O limite é do
// formulário inteiro, somando os arquivos de todos os cursos declarados, então quem confere é a
// página no submit — nenhum campo sozinho enxerga esse total.
export const MAX_TOTAL_UPLOAD_SIZE_MB = 45
